/** Yield a task without depending on vsync, which browsers suspend in hidden tabs. */
function backgroundTask(win: Window): Promise<number> {
  return new Promise((resolve) => {
    const channel = new MessageChannel();
    channel.port1.onmessage = () => {
      channel.port1.close();
      channel.port2.close();
      resolve(win.performance.now());
    };
    channel.port2.postMessage(null);
  });
}

/** Give the browser a rendering opportunity between bounded build jobs. Posted tasks continue in
 * inactive previews too; animation frames can stop there and even a 0 ms timer can clamp to 1 s. */
export function afterNextPaint(win: Window): Promise<number> {
  return backgroundTask(win);
}
